import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { ApiService } from '@angular/synthrone-design/services';
import { MessagesService } from '@angular/synthrone-design/services/messages/messages.service';
import { APP_CONFIG } from '@synthroneApp/app.config';

import { MatDialog } from '@angular/material';
import { AddUpdateFeatureVariantComponent } from '@synthroneApp/components/forms/add-update-feature-variant/add-update-feature-variant.component';

import { FeatureServiceSDK } from 'ms-client-angular-sdk';

@Component({
  selector: 'app-organizations-features-view',
  templateUrl: './organizations-features-view.component.html',
  styleUrls: ['./organizations-features-view.component.scss']
})

export class OrganizationsFeaturesViewComponent implements OnInit {

  @ViewChild('featuresTable') featuresTable;

  configColumns = {
    name: {
      label: 'Feature Name',
      sortable: false,
      truncate: true,
      style: {
        flexGrow: 0.5
      }
    }
  };

  queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
  timeout = null;
  organizationPlanet: string;
  description: String = '';
  total: any;
  systemApplications: any[] = [];
  clientFeatures: any[] = [];
  applicationsSet: Set<string> = new Set();
  buildBlock: any = [];
  blocks: any = [];
  features: any = [];
  params: any = {};
  isBlockValid = false;
  detailsColumn = false;
  actionName: string;
  activeBlock: string;
  paramValue: string;
  blocksContainer: any = [];
  blockIsBeingEdited: any = false;
  feature: any;
  editType = '';
  requiredParams = 0;
  isValid = false;
  nameUnique = true;
  changedModelEdit = false;
  additionalSaveAttributes: any = ['id', 'name', 'description'];
  additionalSaveAttributesEdit: any = ['featureId', 'name', 'description'];


  constructor(private _router: Router, private route: ActivatedRoute, protected api: ApiService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog, private cdRef: ChangeDetectorRef, private messagesService: MessagesService, private featureService: FeatureServiceSDK) { }

  ngOnInit() {
      this.organizationPlanet = this.route.snapshot.params['planet']
  }

  refreshTable = () => {
      this.featuresTable.getData()
  };

  showSnackBar = (info) => {
    this.messagesService.showSnack(info, 'info');
  }

  getFeatures = (): Observable<any> => {
    this.api.makeSDKRequest(this.featureService, 'clientFeaturesGet', false, this.organizationPlanet).subscribe((result: any) => {
      this.clientFeatures = result;
    });

    return this.api.makeSDKRequest(this.featureService, 'featuresGet').flatMap((result: any) => {
      this.total = result.length;
        result.forEach(f => {

          if (f['dependencies'] && f['dependencies']['applications'] && f['dependencies']['applications'].length > 0) {
            f['dependencies']['applications'].forEach(a => {
              let appName = a.split('.')[1]
            this.applicationsSet.add(appName.charAt(0).toUpperCase() + appName.slice(1));
            });
          }
        });
        this.systemApplications = Array.from(this.applicationsSet);
        this.cdRef.detectChanges();
        this.features = result;
        return Observable.of(result);
      });
  }

  toggleFeature = (item) => {
    this.getFeature(item.name);
    const overlay = document.createElement('div');
    const slider: any = event.target;
    const row = slider.closest('.mat-row');

    if (Object.keys(item.configuration).length != 0 && slider.checked) {
      this.editBlock(item);
      this.showSnackBar('Configure feature before enabling it.');
    } else {
      overlay.className = 'requestOverlay';
      overlay.innerHTML = '<div class="loader"></div>';
      overlay.addEventListener('click', () => { event.stopPropagation() });
      row.appendChild(overlay);

      if (slider.checked) {
        this.featureService.clientFeatureNamePost(item.name, this.feature, this.organizationPlanet as string).subscribe(
          (result) => {
            row.removeChild(overlay);
          },
          (error) => {
            row.removeChild(overlay);
          })
          slider.checked = true;
      } else {
        this.featureService.clientFeatureNameDelete(item.name, this.organizationPlanet as string).subscribe(
          (result) => {
            row.removeChild(overlay);
          },
          (error) => {
            row.removeChild(overlay);
          });
          setTimeout(() => {this.refreshTable()}, 500);
      }
    }
  }

  rowClicked = (row) => {
    const clickedElement: any = event.target;
    const clickedRow = (clickedElement.classList.contains('mat-cell') ? clickedElement.parentElement : clickedElement);
    const activeRow = document.querySelector('.active-row');
    if (!clickedRow.classList.contains('active-row')) {
      if (activeRow) {
        activeRow.classList.remove('active-row');
      }
      clickedRow.classList.add('active-row');
      this.description = row.description;
    }
  }

  setConfiguration($status) {
      this.getFeature(this.paramValue);
      this.params = this.feature['configuration'];
      if ($status) {
          this.setRadioButtons();
      }
      this.getRequiredParams();
  }

  setRadioButtons() {
      Object.keys(this.feature['configuration']).forEach((key, index) => {
          if (this.feature['configuration'][key]['type'] == 'radio') {
              this.buildBlock[key] = this.feature['configuration'][key]['options'][0]['value'];
          }
      });
  }

  getRequiredParams() {
      this.requiredParams = 0;
      Object.keys(this.params).forEach((key, index) => {
          if (this.params[key]['required']) {
              this.requiredParams++;
          }
      });
  }

  getFeature(name) {
    this.features.forEach((item, i) => {
      if(item.name == name) {
        this.feature = item;
      }
    });
  }

  editBlock(item) {
      this.getFeature(item.name);
      let clientFeature = this.clientFeatures.find(f => f.name === item.name);

      this.dialog.open(AddUpdateFeatureVariantComponent, {
        height: '600px',
        width: '800px',
        data: {
            featureConfiguration: this.feature['configuration'],
            clientFeatureConfiguration: clientFeature ? clientFeature['configuration'] : {},
            name: this.feature.name,
            callback: (params: any) => {
              for (let key in params['params']) {
                this.feature['configuration'][key] = params['params'][key];
              }
              if (this.checkIfEnabled(item)) {
                return this.featureService.clientFeatureNamePut(this.feature.name, this.feature, this.organizationPlanet as string);
              } else {
                return this.featureService.clientFeatureNamePost(this.feature.name, this.feature, this.organizationPlanet as string);
              }
            }
        },
        panelClass: 'no-padding-container'
      }).afterClosed().subscribe((response) => {
          this.refreshTable();
      });
  }

  public checkConfigurationButton = (item) => {
    if(item.configuration.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getApplications = (item) => {
    let applications = [];
    if (item['dependencies'] && item['dependencies']['applications'] && item['dependencies']['applications'].length > 0) {
      item['dependencies']['applications'].forEach(a => {
        let appName = a.split('.')[1]
        applications.push(appName.charAt(0).toUpperCase() + appName.slice(1));
      });
    }
    return applications.join(', ');
  }

  checkIfEnabled = (item) => {
    let clientFeatuesNames = this.clientFeatures.map(f => f.name);
    return clientFeatuesNames.includes(item.name);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/organizations-features-view/organizations-features-view.component.ts